export { default } from './Checkbox'
export type { ComponentProps as CheckboxProps } from './Checkbox'
